export enum AsyncRules {
    seeGraphs= 'graph-ubolino.see-graphs'
}
